"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var useStyles = {
    "invosys-ui-DataTable": {},
    "invosys-ui-DataTable-fixedHeader": {
        position: "sticky",
        top: 0,
        background: "white"
    },
    "invosys-ui-DataTable-fixedFooter": {
        position: "sticky",
        bottom: 0,
        background: "white"
    },
    "invosys-ui-DataTable-fixedWrapper": {
        height: "100%",
        overflow: "hidden"
    },
    "invosys-ui-DataTable-fixedTableWrapper": {
        height: "calc(100% - 70px)",
        overflow: "auto"
    }
};
exports.default = useStyles;
